import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { updateCollection } from "../../api/apiCollections";
import parseError from "../../utils/parseError";

/**
 * Hook to update an existing collection
 */
export function useUpdateCollection() {
    const queryClient = useQueryClient();

    const {
        mutate: editCollection,
        isPending: isUpdating,
    } = useMutation({
        mutationFn: ({ id, data }) => updateCollection(id, data),
        onSuccess: (response) => {
            toast.success(response.message || "Collection updated successfully");
            queryClient.invalidateQueries({ queryKey: ["collections"] });
            queryClient.invalidateQueries({ queryKey: ["collection"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to update collection");
        },
    });

    return {
        editCollection,
        isUpdating,
    };
}
